module.exports = __webpack_public_path__ + "img/3_mother.90da6c01.jpg";